import { Box, Typography } from '@mui/material';
import { BikeleasingV2ConditionDTO, BikeleasingV2EmployerContributionDTOTypeEnum } from 'probonio-shared-ui/api';
import { useTranslation } from 'react-i18next';

const ConditionField: React.FC<{ label: string; value: string; dataTestId?: string }> = ({ label, value, dataTestId }) => {
  return (
    <Box display="flex" sx={{ flexGrow: 1 }} justifyContent="space-between">
      <Typography mr={5} variant="body2" color="text.secondary" fontWeight="bold">
        {label}
      </Typography>
      <Typography variant="body2" fontWeight="bold" data-test-id={dataTestId}>
        {value}
      </Typography>
    </Box>
  );
};

export const SelectedBikeleasingCondition: React.FC<{ bikeleasingCondition?: BikeleasingV2ConditionDTO }> = ({ bikeleasingCondition }) => {
  const { t } = useTranslation('benefitsModule');
  if (!bikeleasingCondition) {
    return;
  }
  return (
    <>
      {bikeleasingCondition.companyCode && (
        <Typography variant="h3" color="text.secondary" sx={{ mb: 1 }}>
          {t('extensions:bikeleasing_v2_benefit.companyCode', { companyCode: bikeleasingCondition.companyCode })}
        </Typography>
      )}
      {bikeleasingCondition.maxNumberOfBikesPerEmployee && (
        <ConditionField
          value={`${bikeleasingCondition.maxNumberOfBikesPerEmployee}`}
          label={t('extensions:bikeleasing_v2_benefit.maxNumberOfBikesPerEmployee')}
        />
      )}
      {bikeleasingCondition.leasingDurationInMonths && (
        <ConditionField
          value={`${bikeleasingCondition.leasingDurationInMonths}`}
          label={t('extensions:bikeleasing_v2_benefit.leasingDurationInMonths')}
        />
      )}
      {bikeleasingCondition.allowedBikeTypes?.length && (
        <ConditionField
          value={bikeleasingCondition.allowedBikeTypes.join(', ')}
          label={t('extensions:bikeleasing_v2_benefit.allowedBikeTypes')}
        />
      )}

      {bikeleasingCondition.priceRestrictions?.minPurchasePrice && (
        <ConditionField
          value={t('common:money', { money: bikeleasingCondition.priceRestrictions?.minPurchasePrice.grossAmount })}
          label={t('extensions:bikeleasing_v2_benefit.minPurchasePrice')}
        />
      )}
      {bikeleasingCondition.priceRestrictions?.maxPurchasePrice && (
        <ConditionField
          value={t('common:money', { money: bikeleasingCondition.priceRestrictions?.maxPurchasePrice.grossAmount })}
          label={t('extensions:bikeleasing_v2_benefit.maxPurchasePrice')}
        />
      )}
      <ConditionField
        value={
          bikeleasingCondition.priceRestrictions?.maxTotalPurchasePriceForAllBikes
            ? t('common:money', { money: bikeleasingCondition.priceRestrictions?.maxTotalPurchasePriceForAllBikes.grossAmount })
            : '-'
        }
        label={t('extensions:bikeleasing_v2_benefit.priceRestrictions.maxTotalPurchasePriceForAllBikes')}
      />
      {bikeleasingCondition.employerContribution?.type === BikeleasingV2EmployerContributionDTOTypeEnum.Absolute && (
        <ConditionField
          value={t('common:money', { money: bikeleasingCondition.employerContribution.amount })}
          label={t('extensions:bikeleasing_v2_benefit.employerContribution')}
        />
      )}
      {bikeleasingCondition.employerContribution?.type === BikeleasingV2EmployerContributionDTOTypeEnum.Percentage && (
        <ConditionField
          value={`${bikeleasingCondition.employerContribution.percentage}`}
          label={t('extensions:bikeleasing_v2_benefit.employerContribution')}
        />
      )}
    </>
  );
};
